import { Spinner } from "react-bootstrap";
import Select from "react-select";
import { useTranslate } from "../../context/TranslationContext";
import Button from "../button";

const Welcome = ({
  shouldShowBanner,
  user,
  selected,
  setSelected,
  options,
  isLoading,
  handleContinue,
}) => {
  const { t } = useTranslate("countrybanner");
  if (!shouldShowBanner) return null;

  const role = user?.role;

  return (
    <section className="banner fade-in-out">
      <div className="container-fluid text-center">
        <div
          style={{
            backgroundColor: "#17161b",
            padding: "30px",
            borderRadius: "10px",
            maxWidth: "700px",
            margin: "0 auto",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <div className="d-flex flex-column p-5">
            <h2 style={{ marginBottom: "10px", fontWeight: 400 }}>
              {/* Welcome to Traineego */}
              {t("title")}
            </h2>

            <h4 className="mb-2 mt-3" style={{ fontWeight: 400 }}>
              {role === "creator" || role === "both"
                ? t("creatorQuestion")
                : t("learnerQuestion")}
            </h4>

            <p style={{ fontSize: "1.4em", color: "#6c757d" }}>
              {t("subtitle")}
            </p>

            <Select
              options={options}
              value={selected}
              onChange={setSelected}
              isSearchable={false}
              placeholder="Select a country"
              styles={{
                control: (base) => ({
                  ...base,
                  padding: "4px",
                  borderRadius: "12px",
                  height: "3.1em",
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                option: (base, { isFocused, isSelected }) => ({
                  ...base,
                  backgroundColor: isSelected
                    ? "#5d17eb"
                    : isFocused
                      ? "#e9ecef"
                      : "#f8f9fa",
                  color: isSelected ? "#ffffff" : "#000000",
                  cursor: "pointer",
                  ":active": {
                    ...base[":active"],
                    backgroundColor: "#5d17eb",
                  },
                }),
                menuList: (base) => ({
                  ...base,
                  minWidth: "330px",
                  overflowX: "auto",
                  textWrap: "nowrap",
                  maxHeight: "200px",
                  overflowY: "auto",
                }),
              }}
            />

            <Button
              text={
                isLoading ? (
                  <Spinner style={{ color: "var(--primaryColor)" }} />
                ) : (
                  t("continueBtn")
                )
              }
              className="mt-4"
              onClick={handleContinue}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
